var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('iframe',{key:_vm.network,staticClass:"datadog",attrs:{"src":("https://p.datadoghq.com/sb/e72980047-2d709421ba52ff347142795b6c9b92e2?theme=dark&tpl_var_Network=" + _vm.network)}})])}
var staticRenderFns = []

export { render, staticRenderFns }